$(function () {
    //Easy Table of contentsのリンク先を無理やり置換
    $(document).ready(function () {
        let links = $('#ez-toc-container').find('.ez-toc-link');
        links.each(function (index, ele) {
            let hash = links[index]['hash'];
            $(this).attr('href', hash);
        });
        
        // 医療従事者向けポップアップ
        let medical_personnel_dialog = $('.medical-personnel-dialog');
        let medical_session = sessionStorage.getItem("medical_personnel");
        let medical_flg = medical_personnel_dialog.data('medical-flg');
        if (medical_session) {
            $('body').css('display', 'flex');
        } else {
            if (medical_flg == 0) {
                $('body').css('display', 'flex');
            } else {
                // ダイアログを表示
                $('.dialog-bg').css('background', '#fff');
                $(medical_personnel_dialog).show();
                $('body').css('display', 'flex');
            }
        }
        
        
        // ページングを追加
        let page_count = $(".page-num").length;
        if (page_count > 0) {
            for (let i = 1; i < page_count; i++) {
                $('form_feed_' + (i + 1)).hide();
            }
            $('.form_feed_1').addClass('active');
            $('.prev-page').addClass('disabled');
        }
    });
    
    $('.prev-page').on('click', function () {
        let current_page = $('.active').find('a').data('page-num');
        let page_count = $(".page-num").length;
        
        if(current_page !== 'form_feed_1') {
            let num = current_page.replace('form_feed_', '');
    
            $('form_feed_' + num).hide();
            $('.form_feed_' + num).removeClass('active');
    
            $('form_feed_' + (Number(num) - 1)).show();
            $('.form_feed_' + (Number(num) - 1)).addClass('active');
    
            if('form_feed_' + (Number(num) - 1) === 'form_feed_1') {
                $('.prev-page').addClass('disabled');
            }
            $('.next-page').removeClass('disabled');
            $('html, body').animate({ scrollTop: 0 }, 500);
        }
    });
    
    $('.next-page').on('click', function () {
        let current_page = $('.active').find('a').data('page-num');
        let page_count = $(".page-num").length;
        
        if(current_page !== 'form_feed_' + page_count) {
            let num = current_page.replace('form_feed_', '');
    
            $('form_feed_' + num).hide();
            $('.form_feed_' + num).removeClass('active');
    
            $('form_feed_' + (Number(num) + 1)).show();
            $('.form_feed_' + (Number(num) + 1)).addClass('active');
    
            if('form_feed_' + (Number(num) + 1) === 'form_feed_' + page_count) {
                $('.next-page').addClass('disabled');
            }
            $('.prev-page').removeClass('disabled');
            $('html, body').animate({ scrollTop: 0 }, 500);
        }
        
    });
    
    $('.page-num').on('click', function (){
        let page_num = $(this).find('a').data('page-num');
        let page_count = $(".page-num").length;
        
        for (let i = 1; i <= page_count; i++) {
            if(('form_feed_' + i) !== page_num) {
                $('form_feed_' + i).hide();
                $('.form_feed_' + i).removeClass('active');
            } else {
                $('form_feed_' + i).show();
                $('.form_feed_' + i).addClass('active');
            }
        }
        
        // 前後ページやじるしの有効無効きりかえ
        if(page_num === 'form_feed_1') {
            $('.prev-page').addClass('disabled');
        } else {
            $('.prev-page').removeClass('disabled');
        }
        if(page_num === 'form_feed_' + page_count) {
            $('.next-page').addClass('disabled');
        } else {
            $('.next-page').removeClass('disabled');
        }
        $('html, body').animate({ scrollTop: 0 }, 500);
    });
});
